import { render, staticRenderFns } from "./MethaneHistoryTable.vue?vue&type=template&id=c64dac8a&scoped=true"
import script from "./MethaneHistoryTable.vue?vue&type=script&lang=js"
export * from "./MethaneHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./MethaneHistoryTable.vue?vue&type=style&index=0&id=c64dac8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64dac8a",
  null
  
)

export default component.exports